import React from 'react';
import {
    defineBlock,
    smartProps,
    EditableImg,
    EditableHeading,
    EditableText,
    useInspectorControl,
    useSmartProp,
    useEditor,
} from '@smartfire/gutenberg-react';
import clsx from 'clsx';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';

import style from './block.module.scss';

const Inspector = () => {
    const [urlButton, setUrlButton] = useSmartProp('urlButton');

    return (
        <PanelBody title="Configuration du bouton" initialOpen={true}>
            <PanelRow>
                <TextControl label={'Url du bouton'} value={urlButton} onChange={setUrlButton} />
            </PanelRow>
        </PanelBody>
    );
};

const Block = ({ textButton, urlButton }) => {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    const Wrapper = isEditing ? 'div' : 'a';

    return (
        <div className={clsx(style.block, isEditing && style.admin)}>
            <EditableImg className={style.image} smartProp={'image'} />
            <div className={style.content}>
                <div className={style.texts}>
                    <EditableHeading className={style.heading} smartProp={'title'} />
                    {((isEditing && urlButton) || (!isEditing && urlButton && textButton)) && (
                        <Wrapper href={urlButton}>
                            <EditableText className={style.button} smartProp={'textButton'} placeholder="Button" />
                        </Wrapper>
                    )}
                </div>
            </div>
        </div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        title: smartProps.object.withDefault({
            content: '',
            headingLevel: 5,
        }),
        image: smartProps.image,
        textButton: smartProps.string.withDefault(''),
        urlButton: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Home Hero Slide',
    },
});
